<template>
  <div class="box">
    <div class="wrap">
      <div>
        <div class="t">
          <div>
            <i class="iconfont icon-iconfontzhizuobiaozhun22"></i>
          </div>
          <div>
            <input class="search-input-ele" type="text" placeholder="请输入关键字" v-model="value" ref="input" @keyup="change($refs.input.value)" @focus="focus" @blur="blur">
          </div>
        </div>
      </div>
      <div class="cancel" v-if="showConfirm" @click="1">
        搜索
      </div>
      <router-link class="cancel" tag="div" v-else-if="showFilter" to="/search/filter">
         筛选
      </router-link>
      <div class="cancel" @click="back" v-else>
        取消
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  data() {
    return {
      value: ''
    }
  },
  props: {
    change: {
      type: Function,
      default: function() {
      }
    },
    focus: {
      type: Function,
      default: function() {
      }
    },
    blur: {
      type: Function,
      default: function() {
      }
    },
    showFilter: {
      type: Boolean,
      default: false
    },
    showConfirm: {
      type: Boolean,
      default: false
    }
  },
  created() {
  },
  methods: {
    back: function() {
      this.$router.back()
    },
    autofocus() {
      this.$refs.input && this.$refs.input.focus()
    }
  },
  mounted: function() {
    // this.$refs.input.focus()
    // let first = true
    // document.body.addEventListener('touchstart', this.touchstart = (evt) => {
    //   if (first) {
    //     evt.preventDefault()
    //     evt.stopPropagation()
    //     this.$refs.input.focus()
    //     first = false
    //   }
    // })
  },
  beforeDestroy: function() {
    // document.body.removeEventListener('touchstart', this.touchstart)
  },
  watch: {
    value: function(val) {
      this.change(val)
    }
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .box
    padding size(30)
    box-shadow: 0 1px 3px 2px rgba(0,0,0,0.06)
  .wrap
    display flex
    >div:first-child
      flex 1
  .cancel
    line-height size(60)
    padding-left size(20)
    font-size size(32)
    color $color-theme
  .t
    display table
    width 100%
    height size(60)
    background #f0f0f0
    padding 0 size(24)
    border-radius size(28)
    color #999
    >div
      display table-cell
      vertical-align middle
    input
      width 100%
      font-size size(28)
      // padding size(8) 0
      outline none
      background transparent
      height size(40)
      line-height size(40)
  @media only screen and (min-width: 768px){
    .wrap{
      width: 600px
      margin: 0 auto
    }
  }
/*  @media only screen and (min-width: 1280px) {
    .wrap{
      width: 80%
      margin: 0 auto
    }
  } */
</style>



// WEBPACK FOOTER //
// src/components/search/search.vue